import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CurrentOffer } from '../../utils/backend-api/groupSubscription';
import { CustomToaster } from '../BaseUI';
import FooterSection from '../Referral/Landing/FooterSection';
import HeaderSection from './HeaderSection';

const client = new QueryClient();

const Gift = ({ currentOffer }: { currentOffer: CurrentOffer }) => {
  return (
    <QueryClientProvider client={client}>
      <CustomToaster />
      <HeaderSection currentOffer={currentOffer} />
      <FooterSection />
    </QueryClientProvider>
  );
};

export default Gift;
